import React, { Component } from 'react'
import UsersModel from '../models/UsersModel'
import { Row, Col, Alert, Button } from 'antd'
import { Link } from 'react-router-dom'

class PublicRecover extends Component {

    constructor(props) {
        super(props)
        this.state = {
            password: '',
            confirm_password: '',
            generated_password: ''
        }
    }

    generatePassword() {
        var state = Object.assign({}, this.state)
        state.password = state.confirm_password = state.generated_password = UsersModel.generatePassword()
        this.setState(state)
    }

    updateForm(field, value) {
        const formData = this.state
        formData[field] = value
        this.setState(formData)
    }

    loading() {
        var state = Object.assign({}, this.state)
        state.loading = true
        this.setState(state)
    }

    validatePassword() {
        const result = !this.state.password || (
            (this.state.password === this.state.confirm_password)
            && (this.state.password.length >= 8)
        )
        return result
    }

    onSubmit() {
        if (!this.validatePassword()) {
            return
        }
        var formData = {
            recover_token: this.props.match.params.token,
            password: this.state.password
        }
        this.loading()
        this.props.recover(formData)
    }

    render() {
        return (
            <div style={{marginTop: '24px'}}>
                <form method="post" onSubmit={(e) => {
                    e.preventDefault()
                    this.onSubmit()
                }}>
                    <Row>
                        <Col xs={24} sm={6}></Col>
                        <Col xs={24} sm={14}><legend>Alterar Password</legend></Col>
                    </Row>

                    <div className="ant-row ant-form-item">
                        <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                            <label htmlFor="password" className="ant-form-item-required" title="Password">
                                Nova Password
                            </label>
                        </div>
                        <div className="ant-form-item-control-wrapper ant-col-xs-20 ant-col-sm-10">
                            <input id="password"
                                type="password"
                                className="ant-input"
                                value={this.state.password || ''}
                                ref="password"
                                onChange={(e) => this.updateForm('password', e.target.value)}
                            />
                            { !this.validatePassword() ? (
                                <Alert message="A password deve ter pelo menos 8 caracteres e deve ser confirmada" type="error" showIcon />
                            ) : '' }
                        </div>
                        <div className="ant-form-item-control-wrapper ant-col-xs-1 ant-col-sm-1">
                            <Button id="generate" icon="safety"
                                title="Gerar password segura"
                                onClick={(e => this.generatePassword())}
                            />
                        </div>
                        <div className="ant-form-item-control-wrapper ant-col-xs-3 ant-col-sm-3">
                            <input id="generated_password"
                                type="text"
                                className="ant-input ant-input-disabled"
                                readOnly={true}
                                value={this.state.generated_password || ''}
                                ref="generated_password"
                                onChange={(e) => this.updateForm('generated_password', e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="ant-row ant-form-item">
                        <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                            <label htmlFor="password" className="ant-form-item-required" title="Confirmar password">
                                Confirmar Password
                            </label>
                        </div>
                        <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                            <input id="confirm_password"
                                type="password"
                                className="ant-input"
                                value={this.state.confirm_password || ''}
                                ref="confirm_password"
                                onChange={(e) => this.updateForm('confirm_password', e.target.value)}
                            />
                        </div>
                    </div>

                    <Row>
                        <Col xs={24} sm={6}></Col>
                        <Col xs={24} sm={14}>
                            <Alert className={this.props.complete && this.props.error ? '' : 'hidden'}
                                message="Erro"
                                description={this.props.error}
                                type="error"
                                showIcon
                            />
                            <Alert className={this.props.complete && !this.props.error ? '' : 'hidden'}
                                message="Sucesso!"
                                description="A password foi alterada com sucesso."
                                type="success"
                                showIcon
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={24} sm={6}></Col>
                        <Col xs={24} sm={14}>
                            <div style={{borderTop: '2px solid gray', marginTop: '16px', paddingTop: '8px'}}>
                                <button type="submit" className="ant-btn ant-btn-primary" style={{float: 'right'}}>
                                    <span>Definir Password</span>
                                    <i className="anticon anticon-unlock"></i>
                                </button>
                                <Link to="/">Cancelar</Link>
                            </div>
                        </Col>
                    </Row>

                </form>
            </div>
        )
    }
}

export default PublicRecover;



// WEBPACK FOOTER //
// ./src/components/PublicRecover.js